export default {
  data: [{
    id: 4,
    attributes: {
      number: '04',
      category: 'digital innovation team',
      title: 'Our Process',
      subtitle: 'Partners',
      createdAt: '2022-11-16T10:33:59.384Z',
      updatedAt: '2022-11-19T01:26:12.274Z',
      publishedAt: '2022-11-16T10:43:23.194Z',
      body: [{
        id: 1,
        __component: 'service.section-partners',
        satisfied_clients: 183,
        behance_count: '2k',
        questions_title: 'Still have questions?',
        questions_description: 'Can’t find the answer you’re looking for?\nPlease chat with our friendly team.',
        support_title: 'Professionals  support  ',
        support_description: 'We recieve thousdands email every month from people who involved\ninside product design and engineering industries that our work is\nsome of the best in the world. ',
        partner: [{
          id: 1,
          quote: 'Milkinside has catapulted\nour products forward',
          name: 'Raphael Oberholzer',
          role_and_company: 'Investor, CEO of AVA coporation',
          image: {
            data: {
              id: 51,
              attributes: {
                name: 'review.jpg',
                alternativeText: 'review.jpg',
                caption: 'review.jpg',
                width: 640,
                height: 330,
                formats: {
                  small: {
                    ext: '.jpg',
                    url: 'https://res.cloudinary.com/dm3bdznon/image/upload/v1668818934/small_review_6609021cc1.jpg',
                    hash: 'small_review_6609021cc1',
                    mime: 'image/jpeg',
                    name: 'small_review.jpg',
                    path: null,
                    size: 12.36,
                    width: 500,
                    height: 258,
                    provider_metadata: {
                      public_id: 'small_review_6609021cc1',
                      resource_type: 'image',
                    },
                  },
                  thumbnail: {
                    ext: '.jpg',
                    url: 'https://res.cloudinary.com/dm3bdznon/image/upload/v1668818934/thumbnail_review_6609021cc1.jpg',
                    hash: 'thumbnail_review_6609021cc1',
                    mime: 'image/jpeg',
                    name: 'thumbnail_review.jpg',
                    path: null,
                    size: 4.5,
                    width: 245,
                    height: 126,
                    provider_metadata: {
                      public_id: 'thumbnail_review_6609021cc1',
                      resource_type: 'image',
                    },
                  },
                },
                hash: 'review_6609021cc1',
                ext: '.jpg',
                mime: 'image/jpeg',
                size: 17.1,
                url: 'https://res.cloudinary.com/dm3bdznon/image/upload/v1668818934/review_6609021cc1.jpg',
                previewUrl: null,
                provider: 'cloudinary',
                provider_metadata: {
                  public_id: 'review_6609021cc1',
                  resource_type: 'image',
                },
                folderPath: '/',
                createdAt: '2022-11-19T00:48:54.723Z',
                updatedAt: '2022-11-19T00:48:54.723Z',
              },
            },
          },
        }],
        questions_image: {
          data: {
            id: 52,
            attributes: {
              name: 'got-questions.png',
              alternativeText: 'got-questions.png',
              caption: 'got-questions.png',
              width: 246,
              height: 156,
              formats: {
                thumbnail: {
                  ext: '.png',
                  url: 'https://res.cloudinary.com/dm3bdznon/image/upload/v1668820511/thumbnail_got_questions_579d3d6a6d.png',
                  hash: 'thumbnail_got_questions_579d3d6a6d',
                  mime: 'image/png',
                  name: 'thumbnail_got-questions.png',
                  path: null,
                  size: 55.74,
                  width: 245,
                  height: 155,
                  provider_metadata: {
                    public_id: 'thumbnail_got_questions_579d3d6a6d',
                    resource_type: 'image',
                  },
                },
              },
              hash: 'got_questions_579d3d6a6d',
              ext: '.png',
              mime: 'image/png',
              size: 42.35,
              url: 'https://res.cloudinary.com/dm3bdznon/image/upload/v1668820511/got_questions_579d3d6a6d.png',
              previewUrl: null,
              provider: 'cloudinary',
              provider_metadata: {
                public_id: 'got_questions_579d3d6a6d',
                resource_type: 'image',
              },
              folderPath: '/',
              createdAt: '2022-11-19T01:15:12.312Z',
              updatedAt: '2022-11-19T01:15:12.312Z',
              related: {
                data: [{
                  id: 1,
                  attributes: {
                    __type: 'service.section-partners',
                    satisfied_clients: 183,
                    behance_count: '2k',
                    questions_title: 'Still have questions?',
                    questions_description: 'Can’t find the answer you’re looking for?\nPlease chat with our friendly team.',
                    support_title: 'Professionals  support  ',
                    support_description: 'We recieve thousdands email every month from people who involved\ninside product design and engineering industries that our work is\nsome of the best in the world. ',
                  },
                }],
              },
              folder: { data: null },
              createdBy: {
                data: {
                  id: 1,
                  attributes: {
                    firstname: 'Oluwanifemi',
                    lastname: 'Adeyemi',
                    username: null,
                    email: 'deyeminifemi@gmail.com',
                    password: '$2a$10$Mg0hoScYdo.WsSe2Qdu2SeWlSoD.BPJn4EIPWCu/i3a7GC5nBtQHG',
                    resetPasswordToken: null,
                    registrationToken: null,
                    isActive: true,
                    blocked: false,
                    preferedLanguage: null,
                    createdAt: '2022-10-16T20:24:14.006Z',
                    updatedAt: '2022-10-16T20:24:14.006Z',
                  },
                },
              },
              updatedBy: {
                data: {
                  id: 1,
                  attributes: {
                    firstname: 'Oluwanifemi',
                    lastname: 'Adeyemi',
                    username: null,
                    email: 'deyeminifemi@gmail.com',
                    password: '$2a$10$Mg0hoScYdo.WsSe2Qdu2SeWlSoD.BPJn4EIPWCu/i3a7GC5nBtQHG',
                    resetPasswordToken: null,
                    registrationToken: null,
                    isActive: true,
                    blocked: false,
                    preferedLanguage: null,
                    createdAt: '2022-10-16T20:24:14.006Z',
                    updatedAt: '2022-10-16T20:24:14.006Z',
                  },
                },
              },
            },
          },
        },
      }],
    },
  }, {
    id: 3,
    attributes: {
      number: '03',
      category: 'Clients',
      title: 'Milkinside San Francisco',
      subtitle: 'Our heart',
      createdAt: '2022-11-16T09:43:58.519Z',
      updatedAt: '2022-12-31T13:57:45.630Z',
      publishedAt: '2022-11-16T10:43:19.833Z',
      body: [{
        id: 1,
        __component: 'service.section-our-clients',
        title: 'We design digital products and \nservices used by billions globally',
        more_link_text: null,
        users: [{
          id: 13,
          text: 'Spotfiy',
          color: 'black',
        }, {
          id: 16,
          text: 'Alphabet',
          color: 'black',
        }, {
          id: 17,
          text: 'Daimler',
          color: 'black',
        }, {
          id: 18,
          text: 'Microsoft',
          color: 'black',
        }, {
          id: 21,
          text: 'Google',
          color: 'black',
        }, {
          id: 20,
          text: 'Oppo',
          color: 'black',
        }, {
          id: 25,
          text: 'Samsung',
          color: 'black',
        }, {
          id: 28,
          text: 'Mutisbishi',
          color: 'black',
        }, {
          id: 30,
          text: 'GAC Motors',
          color: 'black',
        }, {
          id: 31,
          text: 'Lufthansa',
          color: 'black',
        }, {
          id: 36,
          text: 'Airbus',
          color: 'black',
        }, {
          id: 34,
          text: 'Aston Martin',
          color: 'black',
        }, {
          id: 35,
          text: 'T-Mobile',
          color: 'black',
        }, {
          id: 33,
          text: 'Honda',
          color: 'black',
        }, {
          id: 39,
          text: 'Netflix',
          color: 'black',
        }, {
          id: 40,
          text: 'Apple',
          color: 'black',
        }],
        statistics: [{
          id: 1,
          value: 83,
          description: 'UI Design patents \nwas filed ',
        }, {
          id: 4,
          value: 4,
          description: 'Goverment of \ncountries our clients ',
        }, {
          id: 2,
          value: 48,
          description: 'Startups was \nfucked up by us',
        }, {
          id: 3,
          value: 2,
          description: 'Was fucked hard \nby client ',
        }],
      }],
    },
  }, {
    id: 1,
    attributes: {
      number: '01',
      category: 'digital innovation team',
      title: 'Milkinside San Francisco',
      subtitle: 'Digital Product Strategy',
      createdAt: '2022-11-16T00:00:16.912Z',
      updatedAt: '2022-12-31T15:33:15.297Z',
      publishedAt: '2022-11-16T10:43:11.748Z',
      body: [{
        id: 1,
        __component: 'service.digital-product-strategy',
        top_title: 'Craft experiences that touch \nhearts and lives',
        bottom_title: 'But what do we \nactually do?',
        services: [{
          id: 41,
          text: 'Digital Product Strategy',
          color: 'black',
        }, {
          id: 42,
          text: 'Design-to-Development',
          color: 'black',
        }, {
          id: 44,
          text: 'Accessibility Audits',
          color: 'black',
        }, {
          id: 43,
          text: 'Gap Analysis',
          color: 'black',
        }, {
          id: 45,
          text: 'UX + Heuristic Audits',
          color: 'black',
        }, {
          id: 46,
          text: 'User Experience Design (UX)',
          color: 'black',
        }, {
          id: 47,
          text: 'User Interface Design (UI)',
          color: 'black',
        }, {
          id: 48,
          text: 'Microinteraction Animation',
          color: 'black',
        }, {
          id: 49,
          text: 'Rapid Prototyping',
          color: 'black',
        }, {
          id: 50,
          text: 'Wireframing',
          color: 'black',
        }, {
          id: 52,
          text: 'Information Architecture',
          color: 'black',
        }, {
          id: 51,
          text: 'Design Systems',
          color: 'black',
        }, {
          id: 53,
          text: 'User Flows',
          color: 'black',
        }, {
          id: 54,
          text: 'User Interviews',
          color: 'black',
        }, {
          id: 55,
          text: 'Usability Testing',
          color: 'black',
        }],
        what_we_do: [{
          id: 56,
          text: 'Operating \nSystem \nDesign',
          color: 'black',
        }, {
          id: 57,
          text: 'Consumer\nVoice\nFirst',
          color: 'black',
        }, {
          id: 58,
          text: 'Automotive\nHMI\nDesign',
          color: 'black',
        }, {
          id: 59,
          text: 'Health\ncare and\nBeauty',
          color: 'black',
        }, {
          id: 60,
          text: 'Finance and\nIntellegence\nproducts',
          color: 'black',
        }],
      }],
    },
  }, {
    id: 2,
    attributes: {
      number: '02',
      category: 'digital innovation team',
      title: 'Our Process',
      subtitle: 'But what do we actually do?',
      createdAt: '2022-11-16T02:46:32.996Z',
      updatedAt: '2022-12-31T15:35:23.077Z',
      publishedAt: '2022-11-16T10:43:16.415Z',
      body: [{
        id: 1,
        __component: 'service.section-what-we-do',
        'what-we-do': [{
          id: 7,
          title: 'Operating\nSystem Design',
          description: 'The biggest consumer \nelectronics companies \nsuch as Xiaomi ',
          clients: [{
            id: 63,
            text: 'Spotfiy',
            color: 'black',
          }, {
            id: 61,
            text: 'Lyft ',
            color: 'black',
          }, {
            id: 62,
            text: 'PWC ',
            color: 'black',
          }],
        }, {
          id: 9,
          title: 'Intelligence \nproducts',
          description: 'The biggest consumer \nelectronics companies \nsuch as Xiaomi ',
          clients: [{
            id: 64,
            text: 'Alphabet',
            color: 'black',
          }, {
            id: 65,
            text: 'Daimler',
            color: 'black',
          }, {
            id: 66,
            text: 'Microsoft ',
            color: 'black',
          }],
        }, {
          id: 10,
          title: 'Voice\nFirst products',
          description: 'The biggest consumer \nelectronics companies \nsuch as Xiaomi ',
          clients: [{
            id: 68,
            text: 'T-Mobile',
            color: 'black',
          }, {
            id: 67,
            text: 'Honda',
            color: 'black',
          }, {
            id: 72,
            text: 'SAS',
            color: 'black',
          }],
        }, {
          id: 12,
          title: 'Ecommerce  \ninnovation',
          description: 'The biggest consumer \nelectronics companies \nsuch as Xiaomi ',
          clients: [{
            id: 69,
            text: 'Google',
            color: 'black',
          }, {
            id: 71,
            text: 'Xiaomi',
            color: 'black',
          }, {
            id: 70,
            text: 'Oppo',
            color: 'black',
          }],
        }, {
          id: 11,
          title: 'Intellegence\nproducts',
          description: 'The biggest consumer \nelectronics companies \nsuch as Xiaomi ',
          clients: [{
            id: 73,
            text: null,
            color: 'black',
          }],
        }, {
          id: 8,
          title: 'B2B and\nIntellegence',
          description: 'The biggest consumer \nelectronics companies \nsuch as Xiaomi ',
          clients: [],
        }],
      }],
    },
  }, {
    id: 5,
    attributes: {
      number: '05',
      category: 'digital innovation team',
      title: 'Our Process',
      subtitle: null,
      createdAt: '2022-11-16T10:45:12.310Z',
      updatedAt: '2022-12-31T15:35:51.731Z',
      publishedAt: '2022-11-16T11:29:54.261Z',
      body: [{
        id: 1,
        __component: 'service.section-faq-schedule',
        navbar_text: 'FAQ',
        footer_title: 'We\'d like to work with you!',
        footer_description: 'If you have an arts-based project in mind for Milkinside & Gleb (ie. exhibition, murals, etc)\nplease email us at interact@milkinside.com.',
        availability: 'TBN',
        type: 'FAQ',
        item: [{
          id: 1,
          title: 'The Beauty Project',
          description: null,
          value_number: '1-3',
          value_title: 'Availability\nweeks',
          value_description: null,
        }, {
          id: 2,
          title: 'The  Show must go on',
          description: null,
          value_number: '4',
          value_title: 'Availability\nweeks',
          value_description: null,
        }, {
          id: 3,
          title: 'Become a long term partner',
          description: 'When we’re not working for our clients, we like to experiment. It helps us think new thoughts, meet new people, create new things, discover beautiful objects, and challenge ourselves.',
          value_number: '5-6',
          value_title: 'Availability\nweeks',
          value_description: null,
        }, {
          id: 4,
          title: 'We are here for one night stand',
          description: null,
          value_number: '8-9',
          value_title: 'Availability\nweeks',
          value_description: null,
        }],
      }],
    },
  }, {
    id: 6,
    attributes: {
      number: '06',
      category: 'digital innovation team',
      title: 'Our Process',
      subtitle: null,
      createdAt: '2022-11-16T11:33:40.759Z',
      updatedAt: '2022-12-31T15:36:53.914Z',
      publishedAt: '2022-11-16T11:33:49.409Z',
      body: [{
        id: 2,
        __component: 'service.section-faq-schedule',
        navbar_text: 'FAQ',
        footer_title: 'We\'d like to work with you!',
        footer_description: 'If you have an arts-based project in mind for Milkinside & Gleb (ie. exhibition, murals, etc)\nplease email us at interact@milkinside.com.',
        availability: 'TBN',
        type: 'Schedule',
        item: [{
          id: 5,
          title: 'Design Week',
          description: null,
          value_number: '13',
          value_title: '-18 Jun 2022',
          value_description: 'San-Francisco',
        }, {
          id: 6,
          title: 'Guidance over governance',
          description: null,
          value_number: '18',
          value_title: 'Aug 2022',
          value_description: 'Berlin',
        }, {
          id: 7,
          title: 'Product Sprints with Milkinside',
          description: null,
          value_number: '02',
          value_title: 'Sep 2022',
          value_description: 'Zurich',
        }, {
          id: 8,
          title: 'The FinTech Design Summit',
          description: null,
          value_number: '11',
          value_title: 'Nov 2022',
          value_description: 'New-York',
        }],
      }],
    },
  }],
  meta: {
    pagination: {
      page: 1,
      pageSize: 10,
      pageCount: 1,
      total: 6,
    },
  },
};
